export default {
  path: 'log/operation_log',
  name: 'operation_log',
  component: () => import('@/pages/system/oper_log/OperationLogList'),
  meta: { title: '业务日志' },
}
